// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import MobileGuestSettingsPopup from './MobileGuestSettingsPopup';
import PopupTrigger from '../../components/popupPanel/PopupTrigger';
import Icon from '../../components/icons/Icon';

// Constants
import { PopupIds, PopupSections } from '../../components/popupPanel/popupConstants';

const MobileGuestSettingsUtil = ({ showMobileGuestSettings }) => (
    <div className="HeaderUtil MobileGuestSettingsUtil">
        <PopupTrigger
            className="header-util-button"
            popupId={PopupIds.GUEST_SETTINGS}
            closeSection={PopupSections.HEADER}
        >
            {() => (
                <div className="header-util-button-content">
                    <Icon name="nav-settings" />
                </div>
            )}
        </PopupTrigger>
        {showMobileGuestSettings && <MobileGuestSettingsPopup />}
    </div>
);

MobileGuestSettingsUtil.propTypes = {
    showMobileGuestSettings: PropTypes.bool,
};

export default MobileGuestSettingsUtil;
